module.exports = __webpack_public_path__ + "img/defaultCoinIco.5726b966.png";